import { useTranslation } from "react-i18next";
import "./LanguageSwitcher.css";

/**
 * Two-state segmented control that flips the i18next language between
 * Spanish and English. The choice is persisted to localStorage via
 * i18next-browser-languagedetector's `caches: ["localStorage"]`.
 */
export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "es").slice(0, 2);

  const setLang = (lng) => {
    if (current === lng) return;
    i18n.changeLanguage(lng);
  };

  return (
    <div
      className={`lang-switcher ${className}`.trim()}
      role="group"
      aria-label="Idioma"
    >
      <button
        type="button"
        className={`lang-switcher-btn${current === "es" ? " is-active" : ""}`}
        onClick={() => setLang("es")}
        aria-pressed={current === "es"}
      >
        ES
      </button>
      <button
        type="button"
        className={`lang-switcher-btn${current === "en" ? " is-active" : ""}`}
        onClick={() => setLang("en")}
        aria-pressed={current === "en"}
      >
        EN
      </button>
    </div>
  );
}
